import {
    RichTableColumns,
} from 'app/types/richtable.types'
import {
    FilterType,
} from 'app/enums/common.enums'
import {
    DamageStatus,
} from 'app/enums/label.enums'

import {
    DamageByContainerType,
} from '../../containers.types'

const getColumns = (
    l: (key: string) => string,
): RichTableColumns<keyof DamageByContainerType>[] => {
    return [
        {
            id: 'damageNumber',
            headerProps: {
                children: l('DAMAGE_NUMBER'),
            },
            mapCellProps: 'damageNumber',
        },
        {
            id: 'damageTypeName',
            headerProps: {
                children: l('REASON'),
            },
            mapCellProps: 'damageTypeName',
            filterField: 'damageTypeName',
            filterType: FilterType.Array,
        },
        {
            id: 'repairingServiceCenter',
            headerProps: {
                children: l('REPAIRING_SERVICE_CENTER'),
            },
            mapCellProps: 'repairingServiceCenter',
            filterField: 'repairingServiceCenter',
            filterType: FilterType.Array,
        },
        {
            id: 'reportedOn',
            headerProps: {
                children: l('REPORTED_ON_UTC'),
            },
            mapCellProps: 'reportedOn',
            componentName: 'DateTimeCell',
        },
        {
            id: 'repairedOn',
            headerProps: {
                children: l('REPAIRED_ON_UTC'),
            },
            mapCellProps: 'repairedOn',
            componentName: 'DateTimeCell',
        },
        {
            id: 'damageStatus',
            headerProps: {
                children: l('STATUS'),
            },
            mapCellProps: 'damageStatus',
            filterField: 'damageStatus',
            filterType: FilterType.Array,
            allowedValuesEnum: DamageStatus,
            componentName: 'EnumValue',
        },
    ]
}

export default getColumns
